"use client"

import { LandingPageSeo } from "components/Seo/LandingPageSeo"
import type { VariantType } from "types"
import type { LandingPage as LandingPageType } from "types/cms"
import { useLocale } from "hooks"
import { siteUrl } from "utils/getSiteUrl"
import { landingPageSlug } from "utils/landingPageSlug"
import { LoadingMask } from "components/LoadingMask"
import { useCMSPageContentTracking } from "lib/cms/hooks/useCMSPageContentTracking"
import { useRedeemReferralPage } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.hooks"
import { LandingPage } from "./LandingPage"
import { LandingPageProvider } from "./LandingPageProvider"
import { PreviewNotification } from "packages/ui-shared/components/PreviewNotification"

export type Props = {
  slug: string
  page: LandingPageType
  preview: boolean
  variants: VariantType[]
  completeUrl?: string
  selectedVariantIndex?: number
  experimentId?: string
  isRedeemReferralPage?: boolean
  featuredProductSku?: string
}

export const LandingPageContainer: React.FC<Omit<Props, "slug">> = ({
  page,
  preview,
  variants,
  completeUrl,
  selectedVariantIndex,
  experimentId,
  featuredProductSku,
  isRedeemReferralPage = false,
}) => {
  const { pageTitle, blocks } = page

  const locale = useLocale()

  useCMSPageContentTracking({
    isPreview: preview,
    experimentId,
    variation: selectedVariantIndex,
  })

  const pageSlug = `${siteUrl}${locale === "en-US" ? "/us" : ""}${completeUrl}`

  useRedeemReferralPage(isRedeemReferralPage)

  return (
    <LandingPageProvider
      pageId={page.id}
      variants={variants}
      featuredProductSku={featuredProductSku}
    >
      <LandingPageSeo title={pageTitle} />
      {preview && (
        <PreviewNotification
          slug={
            completeUrl === `${landingPageSlug}/no-page` ? "/no-page" : pageSlug
          }
          locale={locale}
        />
      )}

      <LandingPage blocks={blocks} />
      <LoadingMask />
    </LandingPageProvider>
  )
}
